import { useTranslations } from "next-intl";
import React, { JSX } from "react";

const TradeModalFooter = ({
  footerPadding,
  handleCompleteRequest,
  loading,
  CLS,
  variant,
  tm,
  Icon,
  WhatsAppButton,
  handleGoToSample,
  isPremiumUser
}: {
  footerPadding: string;
  handleCompleteRequest: () => void;
  loading: boolean;
  CLS: {
    input: string;
    inputErr: string;
    label: string;
    sectionTitle: string;
    sidebarTitle: string;
    sidebarDesc: string;
    closeBtn: string;
    error: string;
    primaryBtn: string;
};
  variant: "buy" | "sell" | "exchange";
  tm: (key: string) => string;
  Icon: {
    box: JSX.Element;
    user: JSX.Element;
    payment: JSX.Element;
    arrowUp: JSX.Element;
    arrowDown: JSX.Element;
    arrowRight: JSX.Element;
    close: JSX.Element;
    whatsapp: JSX.Element;
};
  WhatsAppButton: React.ComponentType;
  handleGoToSample: () => void;
  isPremiumUser: boolean;
}) => {
    const t = useTranslations('tradeModal');
  return (
    <div className={`${footerPadding} border-t border-slate-100 shrink-0`}>
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <button
            onClick={handleCompleteRequest}
            disabled={loading}
            className={`${CLS.primaryBtn}`}
          >
            <span className={variant === "exchange" ? "ml-7" : ""}>
              {loading
                ? t("submit.submitting")
                : variant === "buy"
                  ? tm("buy.completePurchase")
                  : variant === "sell"
                    ? tm("sell.completeSell")
                    : tm("exchange.completeExchange")}
            </span>
            <span className={variant === "exchange" ? "mr-7" : ""}>
              {Icon.arrowRight}
            </span>
          </button>
          <WhatsAppButton />
        </div>
        {!isPremiumUser && (<button
          onClick={handleGoToSample}
          disabled={loading}
          className="w-full rounded-2xl border border-gray-200 bg-white py-3 font-bold text-gray-800 hover:bg-gray-50 disabled:opacity-60 transition-all"
        >
          {variant === "buy" ? tm("requestFreeSample") : tm("sendFreeSample")}
        </button>
        )}
      </div>
    </div>
  );
};

export default TradeModalFooter;
